module.exports = __webpack_public_path__ + "static/media/titi.c467bf4a.mp4";